/**
 * Vocabulaire du domaine, partagé par l'API et l'interface.
 * Les valeurs sont figées ici pour qu'un ajout de type se voie des deux côtés.
 */

export const ACCOUNT_TYPES = ['checking', 'savings'] as const;
export type AccountType = (typeof ACCOUNT_TYPES)[number];

export const CATEGORY_KINDS = ['expense', 'income'] as const;
export type CategoryKind = (typeof CATEGORY_KINDS)[number];

/**
 * `transfer` porte un compte de destination ; `adjustment` sert au recalage
 * manuel d'un solde qui a dérivé.
 */
export const TRANSACTION_TYPES = ['expense', 'income', 'transfer', 'adjustment'] as const;
export type TransactionType = (typeof TRANSACTION_TYPES)[number];

/**
 * Cadence d'un objectif d'épargne. `none` désigne un objectif unique — des
 * vacances qu'on prépare une fois ; les autres rejouent la même cible à chaque
 * échéance, comme une mise de côté mensuelle pour les loisirs.
 */
export const SAVINGS_RECURRENCES = [
  'none',
  'daily',
  'weekly',
  'monthly',
  'quarterly',
  'semiannual',
  'annual',
] as const;
export type SavingsRecurrence = (typeof SAVINGS_RECURRENCES)[number];

export const SAVINGS_RECURRENCE_LABELS: Record<SavingsRecurrence, string> = {
  none: 'une seule fois',
  daily: 'chaque jour',
  weekly: 'chaque semaine',
  monthly: 'chaque mois',
  quarterly: 'chaque trimestre',
  semiannual: 'chaque semestre',
  annual: 'chaque année',
};
